<app-shell icon="close" [breadCrumbs]="['Add Part']" (close)="close()">
  <app-cards-vertical [cardsList]="data.parts | toPartCards" (drilldown)="partSelected($event)">
  </app-cards-vertical>
  <app-action-btn [actions]="[{ action: 'add', icon: 'nfc'}]" (actionClick)="nfcScan()"></app-action-btn>
</app-shell>
